import { DetalhePagamentoComponent } from './components/pagamentos/components/detalhe-pagamento/detalhe-pagamento.component';
import { Routes } from '@angular/router';
import { SobreNosComponent } from './components/sobre-nos/sobre-nos.component';
import { CriarCampanhaComponent } from './components/campanhas/components/criar-campanha/criar-campanha.component';
import { DetalheCampanhaComponent } from './components/campanhas/components/detalhe-campanha/detalhe-campanha.component';
import { HomeCampanhaComponent } from './components/campanhas/home-campanha.component';
import { DashboardsComponent } from './components/dashboards/dashboards.component';
import { MainPortalComponent } from './main-portal/main-portal.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { ActivateAccountComponent } from '@app/auth/components/activate-account/activate-account.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { AuthGuard } from '@app/auth/guard/auth.guard';
import { TermosCondicoesComponent } from './components/termos-condicoes/termos-condicoes.component';
import { PoliticaPrivacidadeComponent } from './components/politica-privacidade/politica-privacidade.component';

export const Portalroutes: Routes = [
  {
    path: '',
    component: MainPortalComponent,
  },
  {
    path: 'sobre-nos',
    component: SobreNosComponent,
  },
  {
    path: 'campanhas',
    component: HomeCampanhaComponent,
  },
  {
    path: 'criar-campanha',
    component: CriarCampanhaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'editar-rascunho/:id',
    component: CriarCampanhaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'editar-rascunho/:nome/:id',
    component: CriarCampanhaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'detalhe-campanha/:id',
    component: DetalheCampanhaComponent,
  },
  {
    path: 'detalhe-campanha/:id/:nome',
    component: DetalheCampanhaComponent,
  },
  {
    path: 'detalhe-campanha/:nome/:id',
    component: DetalheCampanhaComponent,
  },
  {
    path: 'financiar-campanha/:id',
    component: DetalhePagamentoComponent,
  },
  {
    path: 'financiar-campanha/:id/:nome',
    component: DetalhePagamentoComponent,
  },
  {
    path: 'financiar-campanha/:nome/:id',
    component: DetalhePagamentoComponent,
  },
  {
    path: 'dashboads',
    component: DashboardsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboards',
    redirectTo: 'dashboads',
    pathMatch: 'full',
  },
  {
    path: 'perfil',
    component: PerfilComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'perguntas-frequentes',
    component: FaqsComponent,
  },
  {
    path: 'faqs',
    redirectTo: 'perguntas-frequentes',
    pathMatch: 'full',
  },
  {
    path: 'termos-condicoes',
    component: TermosCondicoesComponent,
  },
  {
    path: 'termos-e-condicoes',
    redirectTo: 'termos-condicoes',
    pathMatch: 'full',
  },
  {
    path: 'termos',
    redirectTo: 'termos-condicoes',
    pathMatch: 'full',
  },
  {
    path: 'politica-privacidade',
    component: PoliticaPrivacidadeComponent,
  },
  {
    path: 'politica-de-privacidade',
    redirectTo: 'politica-privacidade',
    pathMatch: 'full',
  },
  {
    path: 'privacidade',
    redirectTo: 'politica-privacidade',
    pathMatch: 'full',
  },
  {
    path: 'activate',
    component: ActivateAccountComponent,
  },
];
